import { UseCasesUI } from "features";

const UseCases = () => {
  return (
    <>
      <UseCasesUI />
    </>
  );
};
export { UseCases };
